module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0042.jpg?v=15e7597b";